module.exports = __webpack_public_path__ + "img/full3-min.368df154.png";